// import { wOrgIdMiddleware } from "../../utils/commonUtils";
import { wOrgIdMiddleware } from "../utils/commonUtils";
import http from "./http";

const RandomGeneratorConfigService = {
     saveRandomGeneratorConfig: wOrgIdMiddleware(async (url,data) => {
    try {
      const response = await http.POST(`${url}visit-schedule`, data);
      console.log("response", response);
      
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  },true),
     updateRandomGeneratorConfig: wOrgIdMiddleware(async (url,id,data) => {
    try {
      const response = await http.PUT(`${url}visit-schedule/${id}`, data);
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  },true),
       getRandomVisitSchedulerList: wOrgIdMiddleware(async (url,query={}) => {
          const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}visit-schedule?${queryString}` );
      return response.data;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),
  getRandomVisitSchedulerById: wOrgIdMiddleware(async (url, id) => {
    try {
      const response = await http.GET(`${url}visit-schedule/${id}`);
      return response.data;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),
  deleteRandomVisitScheduler: wOrgIdMiddleware(async (url,id) => {
    try {
      const response = await http.DELETE(`${url}visit-schedule/${id}`);
      return response.data;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  }),
  updateActiveStatus: wOrgIdMiddleware(async (url,id,data) => {
    // console.log("updateActiveStatus",id,data);
    try {
      const response = await http.PUT(`${url}visit-schedule/${id}`, data);
      return response;
    } catch (error) {
      console.error("Save error", error);
      throw error;
    }
  },true),


}

export default RandomGeneratorConfigService